import { GET_REQUIRE_TYPES, GET_REQUIRE_TYPES_SUCCESS, GET_REQUIRE_TYPES_ERROR, GET_REQUIRE_TYPES_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetRequireTypes = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUIRE_TYPES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_REQUIRE_TYPES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_REQUIRE_TYPES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_REQUIRE_TYPES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetRequireTypes;
